import type { FaireProductEntity } from "../../entity_types/product";

export const p_jbsgcus7qd: FaireProductEntity = {
  token: "p_jbsgcus7qd",
  type: "product",
  name: "Varsity Thanks Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3a26486b5cf41617d4e178b9d0f7c8678717f2a35b68916a4a0dba2383b26c82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2698e3e275fc3e4564ec031497cc1b516aacacf7499d00200f0a26a106e65130.jpeg",
    "https://cdn.faire.com/fastly/02326bb38173ef5d063dd26d5d4745c9c778e4248b05bacea54876d6dd7651f5.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:29.130Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
